// Automatically generated
export const DEFAULT_TOAST_KEYS = [] as const;
export const DEFAULT_TOAST_PROVIDER_KEYS = [] as const;
export const CONFIGURABLE_TOAST_KEYS = [] as const;
export const TOAST_KEYS = [] as const;
